import React, { useState } from "react";
function Login({ change }) 
{
    const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [loggedIn, setLoggedIn] = useState(window.localStorage.getItem('MuckS_LoginState'))
  console.log(loggedIn);
  const [Loginerrors, setLoginerrors] = useState("");
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;


    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Validate email
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    }

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };


  const handleLogout = (e) =>
    {
        e.preventDefault();
        localStorage.removeItem('MuckS_LoginState');
        setLoggedIn(null);
        //navigate('../');
        setFormData({
            email: "",
            password: ""
          });
    }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Form is valid, you can submit or process the data here

      var strPassword = formData.password;
      var strEmail = formData.email;
      try 
      {
        fetch('https://mucksucker.com:3001/api/login', {
          method: 'post',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            strPassword,
            strEmail
          })
         })  
         .then(response => response.text())
         .then((response) => {
             if(response === "Success")
              {
                setLoginerrors("");
                setLoggedIn((strEmail));
                change(strEmail);
              }
              else
              {
                setLoginerrors(response);
              }
         })
         .catch(err => console.log(err));
  
      } 
      catch(err) 
      {
        alert(err);
      }
      // Here set global state
    } else {
      // Form is not valid, display error messages
    }




  };

  const isFormValid = Object.keys(errors).length === 0;

  return (
    <div className="container center">
      <h2>Login</h2>
      {loggedIn ? (
        <div className="success-message"><p>Login successful!</p>
            <div onClick={handleLogout}><p>Logout</p></div>
        </div>
      ) : (
        <div>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Email:</label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            {errors.email && <div className="error">{errors.email}</div>}
          </div>

          <div>
            <label>Password:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
            />
            {errors.password && <div className="error">{errors.password}</div>}
          </div>
          <p className="Errors">{Loginerrors}</p>
          <button type="submit" disabled={!isFormValid}>
            Login
          </button>
        </form>
        
          <a className="center button" href='./Register'>Register</a>
        </div>

        
      )}
      
    </div>
  );
}

export default Login;